import React, { useState } from "react";
import GiftListTableComponent from "./giftListTable.component";
import { useDispatch, useSelector } from "react-redux";
import { getGift, resetGiftDetails } from "modules/loyalty-program/redux";
import { setType } from "modules/loyalty-program/redux/slice/redemptionCenter.slice"
import { hideBackdrop, showBackdrop } from "modules/backdrop";
import { GiftDetailsDialog } from "../../dialog";
import { unwrapResult } from '@reduxjs/toolkit'
import ConfirmationDialog from 'components/dialog/confirmation/confirmationDialog.component'
import { redemptionCenterType } from "modules/loyalty-program/constants"
import { getLang } from "app/feature/constants";

export default function GiftListTableContainer({
  hasGiftAddAccessRight,
  hasGiftEditAccessRight,
  hasGiftActivateOrDeactivateAccessRight,
  data,
  isFetching,
  page,
  search,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  handleCreate,
  handleStatusChange,
  handleReload,
  paginationOptions
}) {
  const dispatch = useDispatch()
  const [isModalOpen, setModalOpen] = useState(false);
  const [confirmationDialogModal] = useState(false);
  const isLoadingGiftListError = useSelector(
    (state) => state.redemptionCenter.isLoadingGiftListError
  );
  const lang = useSelector(state => state.constant.languages)
  const language = useSelector(state => state.profile.language)

  const handleView = (id) => {
    dispatch(setType({ index: redemptionCenterType.gift, type: "view" }));
    dispatch(showBackdrop());
    dispatch(getGift(id))
      .then(unwrapResult)
      .then(() => {
        dispatch(hideBackdrop())
        setModalOpen(true)
      })
  }

  const handleClose = () => {
    dispatch(resetGiftDetails())
    setModalOpen(false);
  }

  return (
    <>
      <GiftListTableComponent
        hasGiftAddAccessRight={hasGiftAddAccessRight}
        hasGiftEditAccessRight={hasGiftEditAccessRight}
        hasGiftActivateOrDeactivateAccessRight={hasGiftActivateOrDeactivateAccessRight}
        data={data}
        isFetching={isFetching}
        page={page}
        search={search}
        rowsPerPage={rowsPerPage}
        language={language}
        totalRecords={totalRecords}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleCreate={handleCreate}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
        handleReload={handleReload}
        isLoadingGiftListError={isLoadingGiftListError}
        paginationOptions={paginationOptions}
        lang={lang}
      />
      <GiftDetailsDialog
        isOpen={isModalOpen}
        handleClose={handleClose}
      />
      <ConfirmationDialog
        isOpen={confirmationDialogModal}
        handleProceed={handleClose}
        type="success"
        title={getLang(lang,"label.GIFT_ADDED_SUCCESSFULLY")}
        rejectOption={false}
        proceedLabel={getLang(lang,"label.ALRIGHT")}
      />
    </>
  );
}
